'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const SocialPinterestBlackAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsx(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M11.9959 2C6.4673 2 2 6.47552 2 11.9959C2 16.2328 4.63266 19.8527 8.3513 21.3089C8.2608 20.5191 8.18676 19.3015 8.3842 18.4377C8.5652 17.6561 9.55244 13.4685 9.55244 13.4685C9.55244 13.4685 9.25628 12.868 9.25628 11.9877C9.25628 10.5973 10.0625 9.56068 11.0662 9.56068C11.9218 9.56068 12.3332 10.2024 12.3332 10.9675C12.3332 11.8231 11.7902 13.1065 11.5023 14.2995C11.2637 15.2949 12.0041 16.1094 12.9831 16.1094C14.7602 16.1094 16.1259 14.2336 16.1259 11.5352C16.1259 9.1411 14.4064 7.471 11.9465 7.471C9.09996 7.471 7.42986 9.6018 7.42986 11.8067C7.42986 12.6623 7.75894 13.5837 8.1703 14.0856C8.25258 14.1843 8.2608 14.2748 8.23612 14.3735C8.16208 14.6861 7.9893 15.369 7.9564 15.5088C7.91526 15.6898 7.8083 15.731 7.61908 15.6405C6.38502 15.0481 5.61168 13.2217 5.61168 11.7573C5.61168 8.60634 7.8988 5.7104 12.218 5.7104C15.6816 5.7104 18.3801 8.17852 18.3801 11.4858C18.3801 14.9329 16.2081 17.7055 13.197 17.7055C12.1851 17.7055 11.2308 17.1789 10.9099 16.5537C10.9099 16.5537 10.4081 18.4624 10.2847 18.9313C10.0625 19.8034 9.45372 20.8893 9.04236 21.5557C9.98026 21.8437 10.9675 22 12.0041 22C17.5245 22 22 17.5245 22 12.0041C21.9918 6.47552 17.5162 2 11.9959 2Z",
        fill: "#101010"
      }
    )
  }
);
const VpSocialPinterestBlackAsset = forwardRef(SocialPinterestBlackAsset);

export { VpSocialPinterestBlackAsset as default };
